import "./PersonItem.scss";

// Can have 3 colors: Pending (gray), Collaborator (blue), Admin (green)
function PersonItem({
  name,
  role,
  onClick,
  isSelected,
  showDelete,
  onDelete,
  isCurrentUser,
}) {
  const handleDeleteClick = (e) => {
    e.stopPropagation(); // Prevent triggering onClick
    if (onDelete) {
      onDelete();
    }
  };

  return (
    <div
      className={`person-item ${isSelected ? "selected" : ""} ${isCurrentUser ? "current-user" : ""}`}
      onClick={onClick}
    >
      <div className={`role-indicator ${role}`}></div>
      <div className="person-info">
        <span className="person-name">{name}</span>
        {role !== "user" && role !== "member" && (
          <span className="role-label">({role})</span>
        )}
      </div>
      {showDelete && (
        <button className="delete-button" onClick={handleDeleteClick}>
          <span className="material-symbols-outlined">person_remove</span>
        </button>
      )}
    </div>
  );
}

export default PersonItem;
